<template>
  <div class="content-box">
    <Title />
    <div class="title-right">
      <el-link href="https://www.100ec.cn/detail--6649917.html" target='_blank'>
        <img src="/zt/2024lsbg/img/460.gif"
      /></el-link>
      
    </div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        :index="String(index + 1)"
        v-for="(i, index) of dataNav"
        :key="index"
        @click="handleSelect(index)"
      >
        {{ i.label }}</el-menu-item
      >
    </el-menu>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in dataNav"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <div>
      <div v-loading="$store.state.loading">
        <div class="text">
          <a
            v-for="(i, index) in $store.state.text"
            :key="index"
            :href="'/detail--' + i.id + '.html'"
            target="_blank"
          >
            <div class="img">
              <el-image
                v-if="index <= 40"
                :src="require('@/assets/' + index + '.jpg')"
                lazy
              ></el-image>
              <el-image
                v-else
                :src="require('@/assets/' + (index % 40) + '.jpg')"
                lazy
              ></el-image>
            </div>
            <div class="con">
              <span v-html="i.title"></span>
              <p>{{ i.post_date.split(/T|Z/).join(" ") }}</p>
            </div>
          </a>
        </div>
      </div>

      <div v-if="$store.state.more" class="more">
        <el-button type="primary" plain @click="handleSelect3">
          查看更多</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
    return {
      activeIndex: "1",
      name: "滚动播报",
      list: "1",
      iflist: "数字零售",
      dataNav: [
        {
          value: "数字零售",
          label: "滚动播报",
        },
        {
          value: "新零售",
          label: "新零售",
        },
        {
          value: "同城零售",
          label: "同城零售",
        },
        {
          value: "无人零售",
          label: "无人零售",
        },
        {
          value: "直播 电商",
          label: "直播",
        },
        {
          value: "社交 电商",
          label: "社交",
        },
        {
          value: "社区团购",
          label: "社区团购",
        },
        {
          value: "农村 电商",
          label: "农村",
        },
        {
          value: "生鲜 电商",
          label: "生鲜",
        },
        {
          value: "汽车 电商",
          label: "汽车",
        },
        {
          value: "二手 电商",
          label: "二手",
        },
        {
          value: "母婴 电商",
          label: "母婴",
        },
        {
          value: "奢侈品 电商",
          label: "奢侈品",
        },
        {
          value: "医药 电商",
          label: "医药",
        },
        {
          value: "服装 电商",
          label: "服装",
        },
        {
          value: "电商服务商",
          label: "电商服务商",
        },
        {
          value: "文玩",
          label: "文玩",
        },
        {
          value: "酒水",
          label: "酒水",
        },
        {
          value: "前置仓",
          label: "前置仓",
        },
        {
          value: "双11",
          label: "双11",
        },
        {
          value: "双12",
          label: "双12",
        },
        {
          value: "年货节",
          label: "年货节",
        },
        {
          value: "618",
          label: "618",
        },
        {
          value: "C2M",
          label: "C2M",
        },
        {
          value: "M2C",
          label: "M2C",
        },
        {
          value: "C2B",
          label: "C2B",
        },
        {
          value: "奥莱",
          label: "奥莱",
        },
        {
          value: "特卖",
          label: "特卖",
        },
        {
          value: "电诉宝 零售",
          label: "用户投诉",
        },
        {
          value: "阿里",
          label: "阿里",
        },
        {
          value: "淘宝",
          label: "淘宝",
        },
        {
          value: "天猫",
          label: "天猫",
        },
        {
          value: "京东",
          label: "京东",
        },
        {
          value: "拼多多",
          label: "拼多多",
        },
        {
          value: "小米",
          label: "小米",
        },
        {
          value: "抖音",
          label: "抖音",
        },
        {
          value: "快手",
          label: "快手",
        },
      ],
      params: {
        json: 0,
        filter: ["研报", "分析", "（PPT）", "（全文）"],
      },
    };
  },
  created() {
    this.$store.commit("textparams", this.params);
    // this.$store.commit("changeKeys", this.dataNav[0].value);
    if ((this.dataNav.label = "315曝光")) {
      this.$store.commit("changeKeys", this.list);
      this.$store.dispatch("getText2");
    } else {
      this.$store.dispatch("getText");
    }
    this.$store.state.allNav.forEach((item) => {
      item.child.forEach((j) => {
        if (this.$route.path.indexOf(j.url) != -1) {
          this.title = j.name;
          if (this.title == "首页") {
            this.title = "热点聚焦";
          }

          if (item.more != undefined) {
            this.more = item.more;
          } else if (j.more != undefined) {
            this.more = j.more;
          }
        }
      });
    });
    handleSelect3();
  },
  methods: {
    handleSelect(index) {
      this.iflist = this.dataNav[index].value;
      if (this.dataNav[index].value == "数字零售") {
        this.$store.commit("changeKeys", this.list);
        this.$store.dispatch("getText2");
      } else {
        this.$store.commit("changeKeys", this.dataNav[index].value);
        this.$store.dispatch("getText");
      }
    },
    handleSelect2(value) {
      this.$store.commit("changeKeys", value);
      this.$store.dispatch("getText");
    },
    handleSelect3() {
      if (this.iflist == "数字零售") {
        this.$store.dispatch("getText2");
      } else {
        this.$store.dispatch("getText");
      }
    },
  },
};
</script>
<style scoped>
.title {
  position: relative;
}
.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}
.title-right img {
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }
  .title-right img {
    width: 100%;
    height: 50px;
  }
}
</style>